import React from "react";
import PolarisFormikCheckbox from "../PolarisFormikCheckbox";

export default function BadgeBorderInput() {
  return (
    <PolarisFormikCheckbox label="Border" name="customizations.badge.border" />
  );
}
